import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-5">
            <div className="text-center max-w-md" data-testid="payment-cancel">
                <XCircle className="w-14 h-14 text-faded mx-auto" />
                <h1 className="mt-6 font-serif text-4xl text-cream">Payment cancelled</h1>
                <p className="mt-3 text-ash">No charge was made. Your basket is still waiting whenever you're ready.</p>
                <div className="mt-7 flex gap-3 justify-center">
                    <Link to="/checkout" className="bg-gold text-ink rounded-full px-8 py-3 font-medium hover:bg-goldbright transition-colors">Back to checkout</Link>
                    <Link to="/shop" className="border border-gold/30 text-gold rounded-full px-8 py-3 hover:bg-gold/10 transition-colors">Keep shopping</Link>
                </div>
            </div>
        </div>
    );
}
